/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
import { BoxWithGutters } from "@/components/common/BoxWithGutters";
import ListingCard from "@/components/listing/ListingCard";
import AspectSelect from "@/components/search/AspectSelect";
import AdModule from "@/components/shared/AdModule";
import ListingCarousel from "@/components/shared/ListingCarousel";
import SORT_OPTIONS from "@/constants/SortOptions";
import HomePageSearchRequest from "@/models/HomePageSearchRequest";
import { HomePageSearchResponse } from "@/models/HomePageSearchResponse";
import { Box, Typography } from "@mui/material";
import { SEARCH_ADS } from "../ads";
import { SaveButton } from "@/components/search/SaveButton";

export default function ResultsSection({
  searchPath,
  searchResponse,
  searchRequest,
  handleSearchRequestChange,
  featuredResponse,
}: {
  searchPath: string;
  searchResponse: HomePageSearchResponse;
  searchRequest: HomePageSearchRequest;
  handleSearchRequestChange: (updates: any) => void;
  featuredResponse: HomePageSearchResponse;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        paddingBottom: 0,
        position: "relative",
        ".MuiAutocomplete-root": {
          flexShrink: 0,
        },
      }}
    >
      <BoxWithGutters
        extraPaddingRight
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 4,
          paddingTop: 6,
          [theme.breakpoints.down("lg")]: {
            gap: 2,
          },
        })}
      >
        <Box
          sx={(theme) => ({
            [theme.breakpoints.down("sm")]: {
              flexBasis: "100%",
            },
          })}
        >
          <Typography
            component="span"
            variant="h5"
            sx={{ display: "inline", fontWeight: "bold" }}
          >
            {searchResponse?.results.totalResults}
            &nbsp;
          </Typography>
          <Typography variant="h5" component="h1" sx={{ display: "inline" }}>
            {searchResponse.results.title}
          </Typography>
        </Box>
        <SaveButton type="SEARCH" currentKey={searchPath} />
        <Box sx={{ marginLeft: "auto" }}>
          <AspectSelect
            aspectKey="sort-by"
            aspectLabel="Sort By"
            value={searchRequest.sortBy}
            options={SORT_OPTIONS}
            onValueChange={(sortBy) => handleSearchRequestChange({ sortBy })}
            fullWidth={false}
            size="small"
          />
        </Box>
      </BoxWithGutters>
      <Box
        sx={{
          backgroundColor: "grey.100",
          position: "relative",
        }}
      >
        {featuredResponse?.results?.totalResults > 0 && (
          <ListingCarousel
            title="Featured Ads"
            ads={featuredResponse.results.ads}
            size="small"
            isOnGrey
            placement="AD_IMPRESSIONS#SEARCH#FEATURED"
          />
        )}
        {searchResponse?.results.ads.length >= 8 && (
          <Box
            sx={(theme) => ({
              position: "absolute",
              right: theme.spacing(6),
              top: theme.spacing(2),
              display: "flex",
              flexDirection: "column",
              gap: 4,
              [theme.breakpoints.down("lg")]: {
                right: theme.spacing(2),
              },
              [theme.breakpoints.down("sm")]: {
                display: "none",
              },
            })}
          >
            <AdModule config={SEARCH_ADS.Horsezone_Search_Side_1} />
            <AdModule config={SEARCH_ADS.Horsezone_Search_Side_2} />
          </Box>
        )}
      </Box>
      <AdModule config={SEARCH_ADS.Horsezone_Search_Top} />
      <BoxWithGutters
        extraPaddingRight
        sx={{
          paddingTop: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {featuredResponse?.results?.totalResults > 0 && (
          <Typography variant="h6" component="h2">
            All Results
          </Typography>
        )}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: 4,
          }}
        >
          {searchResponse?.results.ads.map((ad) => (
            <ListingCard key={ad.id} ad={ad} isSearchResult />
          ))}
        </Box>
      </BoxWithGutters>
    </Box>
  );
}
